import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Source Sans Pro', sans-serif;
}
html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}
body {
  overflow-x: hidden;
}
img {
  max-width: 100%;
}
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.5) transparent;
}
*::-webkit-scrollbar {
  width: 0.5px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.5);
  border-radius: 20px;
  border: transparent;
}
`;


export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: clamp(16px, 4vw, 50px);
  padding-left: clamp(16px, 4vw, 50px);
`;

export const Button = styled.button`
  border-radius: 8px;
  background: ${({ primary }) => (primary ? '#00a70a' : '#1E8BB8')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '16px 64px' : '10px 20px')};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  font-weight: 700;
  letter-spacing: 0.5px;
  outline: none;
  border: none;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(0, 44, 3, 0.25);
  transition: all 0.3s ease-out;

  &:hover {
    background-color: ${({ primary }) => (primary ? '#30d51d' : '#33A3D6')};
    transform: translateY(-2px);
    box-shadow: 0 12px 26px rgba(0, 44, 3, 0.3);
  }

  &:focus-visible {
    outline: 3px solid #fff;
    outline-offset: 2px;
  }

  @media screen and (max-width: 960px) {
    width: 100%;
    max-width: 420px;
    padding: ${({ big }) => (big ? '16px 24px' : '10px 20px')};
  }
`;


export default  GlobalStyles;
